export default __webpack_public_path__ + "coffee-cup-on-a-plate-black-silhouettes.png";